import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import * as uiv from 'uiv'
Vue.use(uiv)
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue({})
Vue.mixin({
  methods: {
    formatBirthday (patient) {
      if (!patient.month || !patient.day || !patient.year) return ''

      let month = patient.month
      if (month < 10) {
        month = '0' + month
      }
      let day = patient.day
      if (day < 10) {
        day = '0' + day
      }
      return month + '/' + day + '/' + patient.year
    },
    showAddress (patient) {
      let address = ''
      if (patient.address) {
        address = patient.address
      } else {
        address = patient.streetNumber + (patient.streetName ? ' ' + patient.streetName : '') +
          (patient.suite ? ', ' + patient.suite : '')
      }
      return address +
      (patient.city ? ', ' + patient.city : '') +
      (patient.state ? ', ' + patient.state : '') +
      (patient.zipCode ? ', ' + patient.zipCode : '')
    },
    showCurrentAgePatient (patient) {
      var today = new Date()
      var age = today.getFullYear() - patient.year
      var m = today.getMonth() - patient.month

      if (age === 2 && m < 0) {
        var m = 12 + patient.month - today.getMonth()
        return m + ' mo'
      } else if (age >= 2) {
        return age + ' yo'
      } else if (age === 1 && m <= 0) {
        var m = 12 + patient.month - today.getMonth()
        return m + ' mo'
      } else if (age === 1 && m > 0) {
        var m = 12 + today.getMonth() - patient.month
        return m + ' mo'
      } else if (age === 0) {
        return (m < 0 ? 0 : m) + ' mo'
      } else if (m < 0 || (today.getMonth() == patient.month && today.getDate() < patient.day)) {
        age--
        return age + ' yo'
      }
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
